export default [
  /*{
    url: "/admin",
    name: "Admin Home",
    slug: "admin-home",
    icon: "HomeIcon"
  },*/


  {
    url: "/admin/users",
    name: "User",
    slug: "user",
    icon: "UserIcon",
    i18n: "User"
  },

  /*{
    url: "/admin/coaching-effectiveness",
    name: "Coaching Effectiveness",
    slug: "coaching-effectiveness",
    icon: "UserIcon",
    i18n: "Coaching Effectiveness"
  },*/
  {
    url: "/admin/coach-assignments",
    name: "Assign Coach",
    slug: "assign-coach",
    icon: "UsersIcon",
    i18n: "AssignCoach"
  },
  {
    url: "/admin/schedules",
    name: "Calender",
    slug: "calender",
    icon: "CalendarIcon",
    i18n: "Schedules"
  },
  {
    url: "/admin/consultants",
    name: "Consultants",
    slug: "admin-consultants-menu",
    icon: "BriefcaseIcon"
  },
  {
    url: "/insights",
    name: "Insights",
    slug: "insights",
    icon: "PieChartIcon", // or FileTextIcon
  },
  // {
  //   url: "/user/trainee-list/view",
  //   name: "Trainee List",
  //   slug: "trainee-details-view",
  //   icon: "SmileIcon",
  //   i18n: "CoacheeList"
  // },
  {
    url: "/user/auth/logout",
    name: "Log Out",
    slug: "user",
    icon: "LogOutIcon",
    i18n: "LogOut"
  }
];
